import { createAction, props } from '@ngrx/store';
import { Facility } from '../../interfaces/facility';

export const loadFacilities = createAction('[Facility/API] Load Facilities');

export const loadFacilitiesSuccess = createAction(
  '[Facility/API] Load Facilities Success',
  props<{ facilities: Facility[] }>()
);

export const loadFacilitiesFailure = createAction('[Facility/API] Load Facilities Failure', props<{ error: any }>());

export const createFacility = createAction(
  '[Facility/API] Create Facility',
  props<{ facility: Pick<Facility, 'hereId' | 'headquarters'> }>()
);

export const createFacilitySuccess = createAction(
  '[Facility/API] Create Facility Success',
  props<{ facility: Facility }>()
);

export const createFacilityFailure = createAction('[Facility/API] Create Facility Failure', props<{ error: any }>());

export const updateFacility = createAction('[Facility/API] Update Facility', props<{ facility: Facility }>());

export const updateFacilitySuccess = createAction(
  '[Facility/API] Update Facility Success',
  props<{ facility: Facility }>()
);

export const updateFacilityFailure = createAction('[Facility/API] Update Facility Failure', props<{ error: any }>());

export const deleteFacility = createAction('[Facility/API] Delete Facility', props<{ facility: Facility }>());

export const deleteFacilitySuccess = createAction('[Facility/API] Delete Facility Success', props<{ id: number }>());

export const deleteFacilityFailure = createAction('[Facility/API] Delete Facility Failure', props<{ error: any }>());

export const clearFacilities = createAction('[Facility/API] Clear Facilities');
